/** The register: cards, markers, scope lists, labels, sources, places and areas. */
import type { EndpointDef } from '../endpointTypes'

export const registerRoutes = {
  calculationCards: { method: 'GET', path: '/api/calculation-cards', note: 'The register; query = CalculationCardQuery' },
  propertyMarkers: { method: 'GET', path: '/api/properties/markers', note: 'Map pins for the same query; {data, total, unlocated, truncated}' },
  sourceCatalogue: { method: 'GET', path: '/api/source-catalogue' },
  labels: { method: 'GET', path: '/api/labels' },

  // lists (the memory)
  lists: { method: 'GET', path: '/api/lists', note: '?propertyId marks containsProperty' },
  createList: { method: 'POST', path: '/api/lists' },
  listMembership: { method: 'PUT', path: '/api/lists/:listId/properties/:propertyId', note: 'PUT adds, DELETE removes' },
  listMembershipRemove: { method: 'DELETE', path: '/api/lists/:listId/properties/:propertyId' },

  // places and drawn areas
  geoSuggest: { method: 'GET', path: '/api/geo/suggest', note: '?q= postcode, town, road or admin area' },
  geoAreas: { method: 'GET', path: '/api/geo/areas', note: 'Saved map areas' },
  createGeoArea: { method: 'POST', path: '/api/geo/areas', note: '{name, polygon:[[lat,lng],…]}' },
  deleteGeoArea: { method: 'DELETE', path: '/api/geo/areas/:areaId' },
} as const satisfies Record<string, EndpointDef>
